export default "__VITE_ASSET__a57bd0ba__"